import { Injectable, inject } from '@angular/core';

import { DispatcherService } from '@frontend/sports/common/core/utils/dispatcher';
import { ScrollContainerService } from '@frontend/sports/common/core/utils/scroll-container';
import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { DeviceService, HtmlNode, OnAppInit, WINDOW } from '@frontend/vanilla/core';
import { Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OrientaionChangeService implements OnAppInit {
    private dispatcher = inject(DispatcherService);
    private deviceService = inject(DeviceService);
    private htmlNode = inject(HtmlNode);
    private scrollContainer = inject(ScrollContainerService);
    private productUtils = inject(SportsProductUtils);

    orientationSubscription: Subscription;

    onAppInit(): void | Promise<any> {
        // to be removed
        this.htmlNode.setCssClass('isTablet', this.deviceService.isTablet);
        this.orientationSubscription = this.deviceService.orientation
            .pipe(this.productUtils.filterSportsEmitLast())
            .subscribe((orienation) => this.orientationHandler(orienation));
    }

    private get window(): Window {
        return this._window as Window;
    }

    private orientationHandler = (orientation: string): void => {
        let isLandscape = this.deviceService.currentOrientation === 'landscape';

        if (this.deviceService.isTablet && !this.deviceService.isiOS) {
            isLandscape = !(this.window.screen.availHeight > this.window.screen.availWidth);
        }

        this.htmlNode.setCssClass('landscape', isLandscape);

        if (isLandscape) {
            this.removeVirtualKeyboard();
        }

        this.window.setTimeout(() => {
            this.dispatcher.dispatch('ORIENTATION_CHANGED', { isLandscape });
        });
    };

    private removeVirtualKeyboard(): void {
        const inputs = this.window.document.getElementsByTagName('input');
        if (this.deviceService.isTablet) {
            if (inputs.length > 0) {
                inputs[0].blur();
            }

            this.scrollContainer.scrollTo(0, 0);
        }
    }

    private readonly _window = inject(WINDOW);
}
